export enum WMSListPresentation {
    ICONS = "I",
    TEXT = "T"
}
